import { AppBar, Button, Dialog, Toolbar, Typography } from "@mui/material";
import { APIProvider } from "@vis.gl/react-google-maps";
import type { ReactElement } from "react";
import dayjs, { ISO_DATE_FORMAT } from "../../../dayjs";
import { MAPS_API_KEY, MAPS_LIBRARIES } from "../../../misc/googleMaps";
import type { ProductResponse } from "../productsApi";
import { useProducts } from "../useProducts";
import { ProductMapForProducts } from "./ProductMapForProducts";

export function ProductMapDialog(props: {
  children?: ReactElement<{ product: ProductResponse; date?: string }>;
  open: boolean;
  onClose: () => void;
  date?: string;
  products?: ProductResponse[];
}) {
  const date = props.date ?? dayjs().add(1, "day").format(ISO_DATE_FORMAT);
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      fullWidth
      maxWidth="xl"
      slotProps={{
        paper: { sx: { height: "90%" } },
      }}
    >
      <ProductMapAppBar onClick={props.onClose} />
      <ProductMap date={date} products={props.products}>
        {props.children}
      </ProductMap>
    </Dialog>
  );
}

export function ProductMap(props: {
  children?: ReactElement<{ product: ProductResponse; date?: string }>;
  date?: string;
  products?: ProductResponse[];
}) {
  return (
    <APIProvider apiKey={MAPS_API_KEY} libraries={MAPS_LIBRARIES}>
      {props.products ? (
        <ProductMapForProducts date={props.date} products={props.products}>
          {props.children}
        </ProductMapForProducts>
      ) : (
        <ProductMapAll date={props.date}>{props.children}</ProductMapAll>
      )}
    </APIProvider>
  );
}

function ProductMapAll(props: { children?: ReactElement<{ product: ProductResponse; date?: string }>; date?: string }) {
  const { products } = useProducts();
  return (
    <ProductMapForProducts date={props.date} products={products}>
      {props.children}
    </ProductMapForProducts>
  );
}

function ProductMapAppBar(props: { onClick: () => void }) {
  return (
    <AppBar sx={{ position: "relative" }}>
      <Toolbar>
        <Typography sx={{ flex: 1 }} variant="h6" component="div">
          Mapa
        </Typography>
        <Button autoFocus color="inherit" onClick={props.onClick}>
          Zamknij mapę
        </Button>
      </Toolbar>
    </AppBar>
  );
}
